// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const WordFileIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "WordFile",
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.09 14.71h-2.13L13.25 22l-1.56-7.29h-1.9l2.28 9.74h2.29l1.67-7.49 1.66 7.49h2.19l2.29-9.74h-1.91l-1.51 7.07zm10.13-4.16c-.03-.12-.07-.24-.13-.35v-.08c-.08-.1-.17-.2-.26-.28l-7.51-7.51a1.5 1.5 0 0 0-.29-.22h-.08a2 2 0 0 0-.33-.12H8.99c-2.31 0-4.18 1.86-4.21 4.17v20.09c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74zm-2.84 15.7c0 .77-.76.97-1.4.97H9c-.64 0-1.4-.17-1.4-.97V6.17c0-.77.61-1.4 1.38-1.4h7.96v5.14c0 1.29 1.05 2.34 2.34 2.34h5.1v14.02Z"
    })
  });
};